<template>
  <div class="home" id="home" :class="{'hide-branding': hideBranding}">
    <Logo v-if="!hideBranding" :homepage="homepage" />
    <h3 v-if="!findError">
      Please enter your presentation's access code:
    </h3>
    <h3 v-if="findError">
      Presentation not found. You may have mistyped the access code. Try again?
    </h3>

    <form @submit.prevent="submitAccessCode" class="item-input">
      <input
        type="text"
        class="item-input-text submit-access-placeholder"
        placeholder="Type in access code..."
        v-model="accessCode"
        @input="handleAccessCode"
        :maxlength="10"
        required
      >
      <div class="text-center">
        <ui-button type="submit" size="lg">
          <span>Submit</span>
          <span class="w-20px h-20px">
            <svg

              v-if="!submiting"
              viewBox="0 0 512 512"
              fill="white"
            >
              <!-- eslint-disable-next-line max-len -->
              <path
                d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
              />
            </svg>
            <ui-spinner v-else />
          </span>
        </ui-button>
      </div>
      <div class="text-danger text-center" v-if="error" style="line-height: 1.5rem">
        <svg viewBox="0 0 576 512" class="fa-fw">
          <!-- eslint-disable-next-line max-len -->
          <path d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" />
        </svg>
        <span v-html="error" />
      </div>
    </form>

    <p class="note text-center">
      The code is found on the screen in front of you.
    </p>
  </div>
</template>

<script>
// UI
import UiButton from '@/components/UI/Button'
import UiSpinner from '@/components/UI/Spinner'

import Config from '@/config'
import Util from '@/util'
import Logo from '@/components/Logo'

export default {
  name: 'Home',
  components: {
    Logo,
    UiButton,
    UiSpinner,
  },
  data() {
    return {
      accessCode: '',
      error: '',
      submiting: false,
      findError: false,
      hideBranding: false,
      homepage: true,
    }
  },
  created() {
    this.findError = Util.getParamValue('error', window.location.href)
    if (this.findError) {
      window.history.replaceState('', '', '/')
    }
  },
  mounted() {
    if (document.getElementById('slide-image-bg')) {
      document.getElementById('slide-image-bg').remove()
    }
    document.body.style.backgroundColor = '#ffffff'
    document.body.style.color = '#313131'

    if (window.location.host !== Config.domain) {
      this.hideBranding = true
    }
  },
  methods: {
    validateAcessCode() {
      this.$http
        .get(Config.api.checkPresentation, {
          params: {
            id: this.accessCode,
          },
        })
        .then((doc) => {
          if (!doc.body) {
            throw new Error('No presentation found')
          }
          this.$router.push({
            name: 'Presentation',
            params: { id: doc.body.uniqueAccessCode },
          })
          this.submiting = false
          return true
        })
        .catch(() => {
          this.submiting = false
          this.error = `There's no such presentation with this access code (<span class="text-uppercase">${this.accessCode}</span>). Please try again.`
        })
    },

    submitAccessCode() {
      if (this.submiting) return
      this.submiting = true
      this.error = ''
      this.validateAcessCode()
    },

    handleAccessCode() {
      this.accessCode = this.accessCode.replace(/\s/g, '')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.home {
  max-width: 710px;
  margin: 0 auto;
}

.note {
  padding: 0 16px;
}

h3 {
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 20px;
  padding: 0 16px;
}
.hide-branding {
  h3 {
    margin-top: 40px;
  }
}
.fa-fw{
  text-align: center;
  width: 1.2em;
  margin-bottom: -2px;
}
.item-input {
  padding: 0 16px;
  max-width: 500px;
  margin: 0 auto;
  .item-input-text {
    margin-bottom: 16px;
    text-transform: uppercase;
  }

  .button-submit {
    width: 150px;
    .fas {
      margin-bottom: 4px;
    }
  }
}

.text-danger {
  margin-top: 20px;
  path{
    fill : #ff5050;
  }
}
.submit-access-placeholder::placeholder {
  text-transform: none;
}

</style>
